import { useEffect, useState } from 'react';
import moment from 'moment';
import { EFASVersionApiResponse } from '../Map.types';
import { MapSettingsService } from '../services/MapSettingsService';
import IS_EFAS from '../../../components/sitebase/Environment';


export function useVersionMessage(
    acceptedWelcomeMessage: boolean,
    forecastDate: string,
    remote: MapSettingsService,
) {
    const [data, setData] = useState<EFASVersionApiResponse>({
        body: '',
        link_url: '',
        title: '',
        version: ''
    });

    const getAccepted = () => acceptedWelcomeMessage || window.localStorage.getItem('accepted_welcome_message') === 'true';

    const [accepted, setAccepted] = useState<boolean>(getAccepted());
    const [visible, setVisible] = useState<boolean>(IS_EFAS ? !getAccepted() : false);

    useEffect(() => {
        if (!IS_EFAS) return;
        const isAccepted = acceptedWelcomeMessage || window.localStorage.getItem('accepted_welcome_message') === 'true';
        setAccepted(isAccepted);
        setVisible(!isAccepted);
    }, [acceptedWelcomeMessage]);

    const onAccept = () => {
        if (!IS_EFAS) return;
        setVisible(false);
        setAccepted(true);
        window.localStorage.setItem('accepted_welcome_message', 'true');
        remote.updateUserWebSettings({ accepted_welcome_message: true });
    };

    // This use effect always queries the latest version based on the current time
    useEffect(() => {
        if (!IS_EFAS) return;
        const queryDate = moment.utc().format('YYYY-MM-DDTHH:mm') + 'Z';
        fetch(`/api/version/version/?date=${queryDate}`).then((response) => {
            return response.json();
        }).then((json: EFASVersionApiResponse[]) => {
            if (!json[0]) { return; }
            setData(json[0]);
        }).catch((e) => {
            console.error("Failed to fetch version", e);
        });
    }, []);

    // this use effect runs on forecast changes to show what model version the user is looking at
    // so it only updates the model (data.version) message
    useEffect(() => {
        if (!IS_EFAS || !forecastDate) { return; }
        fetch(`/api/version/version/?date=${forecastDate}`).then((response) => {
            return response.json();
        }).then((json: EFASVersionApiResponse[]) => {
            if (!json[0]) { return; }
            setData(prev => ({ ...prev, version: json[0].version }));
        }).catch((e) => {
            console.error("Failed to fetch version for forecast date", e);
        });
    }, [forecastDate]);

    return {
        data,
        visible,
        setVisible,
        onAccept,
        accepted,
    };
}
